import { render, staticRenderFns } from "./BrowseHome.vue?vue&type=template&id=3dc44ba0&"
import script from "./BrowseHome.vue?vue&type=script&lang=js&"
export * from "./BrowseHome.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports